import Morning from "../img/CourseMorning.svg";
import Night from "../img/CourseNight.svg";

export const weekdaysHelper = (weekdays) => {
  if (weekdays === "Lun, Mie y Vie") return "LUNES, MIÉRCOLES Y VIERNES";
  if (weekdays === "Mar y Jue") return "MARTES Y JUEVES";
  if (weekdays === "Lunes a Viernes") return "LUNES A VIERNES";
};

export const datesHelper = (date) => {
  const timeZoneOffset = new Date(date).getTimezoneOffset();
  const dateToMilisec = new Date(date).getTime();
  const finalDate = new Date(dateToMilisec + timeZoneOffset * 60000);

  const formattedDate = finalDate
    .toLocaleDateString("es-ES", {
      dateStyle: "short",
    })
    .split("/");

  return formattedDate;
};

export const shiftHelper = (shift) => {
  if (shift === "full time") return { icon: Night, shift: "FULL TIME" };
  else if (shift === "mañana") return { icon: Morning, shift: "TURNO MAÑANA" };
  else if (shift === "tarde") return { icon: Night, shift: "TURNO TARDE" };
};

export const hoursHelper = (hour) => {
  const splittedHour = hour.split(":");
  return `${splittedHour[0]}:${splittedHour[1]}`;
};

export const saveOnLS = (info, callback) => {
  localStorage.setItem("data", JSON.stringify(info));
  callback();
};

export const bootcampContentToInfoMapper = (course) => {
  const { weekDays, startDate, endDate, startHour, endHour } = course;

  return {
    "Modalidad:": "Full-time",
    "Días:": weekDays,
    "Nivel:": "Avanzado",
    "Fechas:": `${formatDate(startDate)} al ${formatDate(endDate)}`,
    "Horario:": `de ${formatTime(startHour)} a ${formatTime(endHour)}`,
    "Duración:": "4 meses",
  };
};

export const formatDate = (date, secondary = null) => {
  const standardizedDate = new Date(Date.parse(date));
  if (secondary)
    return `${
      standardizedDate.getUTCDate() < 10
        ? `0${standardizedDate.getUTCDate()}`
        : standardizedDate.getUTCDate()
    }/${
      standardizedDate.getUTCMonth() + 1 < 10
        ? `0${standardizedDate.getUTCMonth() + 1}`
        : standardizedDate.getUTCMonth() + 1
    }/${standardizedDate.getUTCFullYear()}`;
  return `${
    standardizedDate.getUTCDate() < 10
      ? `0${standardizedDate.getUTCDate()}`
      : standardizedDate.getUTCDate()
  }/${
    standardizedDate.getUTCMonth() + 1 < 10
      ? `0${standardizedDate.getUTCMonth() + 1}`
      : standardizedDate.getUTCMonth() + 1
  }`;
};

export const formatTime = (time) => {
  const strandarizedTime = time;
  return strandarizedTime.substring(0, time.length - 3);
};
